import { css } from '@emotion/react';
import { spacing } from '@prototyp/gatsby-plugin-gumball';

export const root = css`
  position: relative;
  top: 100px;
  padding: ${spacing(30)} ${spacing(60)};
`;
